import React from 'react'
import hash from 'object-hash'
import AOS from 'aos'
import 'aos/dist/aos.css';
import moment from 'moment'
import 'moment/locale/es'
import scriptLoader from 'react-async-script-loader'

import { PersonTypeView, UserRegisterView, PlanPricingView, ContractView, PaymentProcessView, ResumeView } from '../../views'
import { ValidateInputPure, DirectionPure, FiscalDataPure, SimpleLoading, MessagePure } from '../../pures'
import { Auth0Service, LocalStorageService, AddressService, PlanService, ClientService, TaxDataService, ContractService, DownloadSignaturesService, PaymentTypeService, MessageService } from '../../../services'
import { DOMUtil } from '../../../utils'
import { RegistrationValidator } from '../../../validators'
import { useTranslation } from "react-i18next"
import imageFisica from '../../../assets/logos/Persona_fisica.png'
import imageMoral from '../../../assets/logos/Persona_moral.png'
import govoLogo from './../../../assets/logos/logo_govo.legal.jpg'
import { PersonalInformation, PhoneValidation, Pricing, TermsCondition, PaymentProcess, Resume, PersonalInformationBlack, PhoneValidationBlack, PricingBlack, TermsConditionBlack, PaymentProcessBlack, ResumeBlack } from '../../../assets/logos/icons'
import { AVISO_PRIVACIDAD } from './../../../utils/constants'
import { formatPhoneNumber } from 'react-phone-number-input'

class RegistrationAction extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
  }
  input = React.createRef();

  state = {
    isDownloadSignaturesData: false,
    firstName: "",
    firstLastName: "",
    secondLastName: "",
    preload: false,
    rfc: "",
    phoneNumber: "",
    cellphoneNumber: "",
    colony: "",
    state: "",
    street: "",
    township: "",
    zipCode: "",
    organization: "",
    creditCard: "",
    expirationDate: "",
    cvv2: "",
    selectedStep: 0, ///cambiar a 0
    firstTry: false,
    planChecked: false,
    personlDataFill: false,
    businessDataFill: false,
    termnsAndConditions: false,
    transferMessage: false,
    transfer: false,
    card: false,
    a3Direct: false,
    messageTransfer: false,
    attempOfPayment: true,
    selectedPersonType: false,
    selectedPersonTypeId: 1,
    selectedPersonTypeName: "Individual",
    selectedPlanPricing: true,
    selectedPlanPricingId: [],
    selectedPlanLevel: {},
    changedTranslates: false,
    loading: false,
    plan: [],
    contractBullets: [],
    warning: false,
    allPlan: [],
    paymentType: [],
    showNotification: false,
    message: "Ocurrio un error",
    messageComplete: '',
    planStandard: "",
    visibleDialogTermsCond: false,
    modalTermsCond: false,
    planEstandarSelectPrice: "$0.00",
    planProSelectPrice: 0,
    classSelectPackageStandar: "",
    classSelectPackagePro: "plan-item-button-active",
    showErrorRequesting: false,
    showCompletedRequesting: false,
    eventId: 0,
    contract: {},
    urlPdfTermsCond: AVISO_PRIVACIDAD,
    isLastStep: false,
    downloadLoading: false,
    contractCreated: false,
    contractCreatedError: false,
    dateResume: "",
    creactedContract: [],
    priceContract: "",
    priceContractA3Card: "",
    validationCode: "",
    validationCodeCorrect: false,
    validationType: "",
    focused: false,

    promotion: false,
    avaliablePlans: [],
    assignedPlans: [],
    assignedPackage: [],

    total: 0,
    iva: 0,
    subtotal: 0,

    physicalSteps: [
      {
        icon: PersonalInformation,
        iconBlack: PersonalInformationBlack,
        itemElement: this.props.t("registration.action.personalData"),
        itemSup: this.props.t("registration.action.Steps.nextLaber"),
        key: "register.personalData",
        labelreturn: this.props.t("registration.action.Steps.exit"),
        label: this.props.t("registration.action.personalData"),
      },
      {
        icon: PhoneValidation,
        iconBlack: PhoneValidationBlack,
        itemElement: this.props.t("registration.action.validation"),
        itemSup: this.props.t("registration.action.Steps.nextLaber"),
        key: "register.address",
        labelreturn: this.props.t("registration.action.Steps.backLaber"),
        label: this.props.t("registration.action.validation"),
      },
      {
        icon: Pricing,
        iconBlack: PricingBlack,
        itemElement: this.props.t("registration.action.plansAndPricing"),
        itemSup: this.props.t("registration.action.Steps.nextLaber"),
        key: "register.plan",
        labelreturn: this.props.t("registration.action.Steps.backLaber"),
        label: this.props.t("registration.action.plansAndPricing"),
      },
      {
        icon: TermsCondition,
        iconBlack: TermsConditionBlack,
        itemElement: this.props.t("registration.action.tos"),
        itemSup: this.props.t("registration.action.Steps.nextLaber"),
        key: this.props.t("registration.action.tos"),
        labelreturn: this.props.t("registration.action.Steps.backLaber"),
        label: this.props.t("registration.action.tos"),
      },
      {
        icon: PaymentProcess,
        iconBlack: PaymentProcessBlack,
        itemElement: this.props.t("registration.action.payment"),
        itemSup: this.props.t("registration.action.Steps.nextPayment"),
        key: this.props.t("registration.action.payment"),
        labelreturn: this.props.t("registration.action.Steps.backLaber"),
        label: this.props.t("registration.action.payment"),
      },
      {
        icon: Resume,
        iconBlack: ResumeBlack,
        itemElement: this.props.t("registration.action.resume"),
        itemSup: this.props.t("registration.action.Steps.gotoapp"),
        key: this.props.t("registration.action.resume"),
        labelreturn: this.props.t("registration.action.Steps.backLaber"),
        label: this.props.t("registration.action.resume"),
      },
    ],
  };

  notification = {
    type: {
      style: "error",
      icon: true,
    },
    style: {
      top: 760,
      right: 20,
      position: "absolute",
    },
  };

  token = {};
  user = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  addressService = new AddressService(this.url);
  clientService = new ClientService(this.url);
  planService = new PlanService(this.url);
  contractService = new ContractService(this.url);
  taxDataService = new TaxDataService(this.url);
  downloadSignaturesService = new DownloadSignaturesService(this.url);
  localStorageService = new LocalStorageService();
  auth0Service = new Auth0Service();
  domUtil = new DOMUtil();
  validator = RegistrationValidator(this.props.t);
  paymentTypeService = new PaymentTypeService(this.url);
  messageService = new MessageService(this.url);

  fisica = {
    name: this.props.t("registration.action.individual"),
    description: this.props.t("registration.action.physicalDescription"),
    information: this.props.t("registration.action.physicalInformation"),
    image: imageFisica,
  };

  moral = {
    name: this.props.t("registration.action.corp"),
    description: this.props.t("registration.action.moralDescription"),
    information: this.props.t("registration.action.moralInformation"),
    image: imageMoral,
  };

  physicalStepMetadata = [
    {
      number: 0,
      component: DirectionPure,
      service: this.addressService,
      method: "createAddress",
    },
    { number: 1, component: MessagePure },
    { number: 2, component: PlanPricingView, action: "validatePlan" },
    { number: 3, component: ContractView, action: "validateContract" },
    {
      number: 4,
      component: PaymentProcessView,
      action: "validatePaymentMethod",
    },
    { number: 5, component: ResumeView },
  ];

  formatter = new Intl.NumberFormat(
    "en-MX",
    { style: "currency", currency: "MXN", currencyDisplay: "narrowSymbol" },
    {
      style: "currency",
      currency: "MXN",
    }
  );

  onChangeValue = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  /**
 * @author Adrian Montemayor
 * @description Change the state of cellphone, with extension
 */
  onChangeCellphone = (number) => {
    this.setState({ cellphoneNumber: number });
  };

  /**
* @author Adrian Montemayor
* @description Change the state of cellphone, with extension
*/
  onChangePhone = (number) => {
    this.setState({ phoneNumber: number });
  };

  /**
   * @author Leonel Contreras
   * @description Change the state to select terms and conditions
   */
  onAcceptTermnsAndConditions = () =>
    this.setState({ termnsAndConditions: !this.state.termnsAndConditions });

  /**
   * @author Leonel Contreras
   * @description Change the state to select plan
   */
  onAcceptPlan = () => this.setState({ planChecked: !this.state.planChecked });

  /**
   * @author Lucia Alvarado
   * @description Change the state to select card
   */
  onAcceptCard = (event) => {
    this.setState({
      card: event ? event.value : !this.state.card,
      transfer: false,
      a3Direct: false,
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Change the state to select transfer
   */
  onAcceptTransfer = () => {
    this.setState({
      transfer: !this.state.transfer,
      card: false,
      a3Direct: false,
    });
  };

  onAcceptA3Direct = () => {
    this.setState({
      a3Direct: true,
      card: false,
      transfer: false,
    });
  };

  onSelectPlanState = () => {
    this.setState({
      card: true,
      transfer: false,
      a3Direct: false,
    })
  }
  /**
   * @author Lucia Alvarado
   * @description Change the state to select message of transfer
   */
  onAcceptMessageTransfer = () =>
    this.setState({ messageTransfer: !this.state.messageTransfer });

  /**
   * @author Lucia Alvarado
   * @description Accept read message of transfer
   */
  onAcceptTransferMessage = () =>
    this.setState({ transferMessage: !this.state.transferMessage });

  /**
   * @author Leonel Contreras
   * @description Close/Open the modal
   */
  onCloseOpenModal = () =>
    this.setState({ showNotification: !this.state.showNotification });

  openModalTermsCond = (value) => {
    this.setState({
      modalTermsCond: value,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the error dialog modal
   * @memberof SignatureRequestAction
   */
  toggleErrorRequesting = (value, message) => {
    this.setState(
      {
        showErrorRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showErrorRequesting: false,
          });
        }, 4000);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the WARNING dialog modal
   * @memberof SignatureRequestAction
   */
  toggleWarningRequesting = (value, message) => {
    this.setState(
      {
        showWarningRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showWarningRequesting: false,
          });
        }, 4000);
      }
    );
  };

  /**
 * @author Adrian Montemayor
 * @description Method to show the Complete dialog modal
 * @memberof SignatureRequestAction
 */
  toggleCompletedRequesting = (value, message) => {
    this.setState(
      {
        showCompletedRequesting: value,
        messageComplete: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCompletedRequesting: false,
          });
        }, 4000);
      }
    );
  };

  onHandleHideError = () => {
    this.setState({
      errorForm: false,
      errorMessage: "",
    });
  };

  /**
   * @author Leonel Contreras
   * Match the features array to allFeatures array and
   * check the set that it has
   * @param {Object[]} allFeatures
   * @param {object[]} features
   */
  planCheckFeature = (allFeatures, features) => {
    let result = [];
    if (typeof features[0].feature.name != "boolean") {
      for (let i = 0; i < allFeatures.length; i++) {
        const element = allFeatures[i].feature.name;
        let finding = {
          feature: {
            name: false,
          },
        };
        for (let j = 0; j < features.length; j++) {
          if (element === features[j].feature.name) {
            finding.feature.name = true;
          }
        }
        result.push(finding);
      }

      return result;
    } else {
      return features;
    }
  };

  /**
   * @author Leonel Contreras
   * @description sum all the features array
   * @param {Object} plan
   */
  getAllPlans = (plan) => {
    let allPlans = [];

    for (let i = 0; i < plan.length; i++) {
      const element = plan[i];

      for (let j = 0; j < element.planFeatures.length; j++) {
        const feature = element.planFeatures[j].feature.name;
        if (allPlans.indexOf(feature) === -1) allPlans.push(feature);
      }
    }

    allPlans = allPlans.map((plan) => {
      return {
        feature: {
          name: plan,
        },
      };
    });
    return allPlans;
  };

  onSelectPlanStandard = (event, plan) => {
    event.preventDefault();
    let classList = event.target.classList;
    let selectedPlanPricingId = event.target.getAttribute("id");

    classList.remove("animate");
    this.domUtil.removeCSSClass("plan-item-button-active", "plan-item-button");
    classList.value = "plan-item-button";

    classList.add("plan-item-button-active");
    classList.add("animate");

    //  setTimeout(() => {
    //    classList.remove('animate')
    //  }, 700)
    this.setState({
      selectedPlanPricing: true,
      selectedPlanPricingId,
      selectedPlanLevel: plan,
      planEstandarSelectPrice: Number(plan.pricing),
      planProSelectPrice: 0,
      classSelectPackageStandar: "plan-item-button-active",
      classSelectPackagePro: "",
    });
  };

  onSelectPlanPro = (event, plan) => {
    event.preventDefault();
    let classList = event.target.classList;
    let selectedPlanPricingId = event.target.getAttribute("id");

    classList.remove("animate");
    this.domUtil.removeCSSClass("plan-item-button-active", "plan-item-button");
    classList.value = "plan-item-button";

    classList.add("plan-item-button-active");
    classList.add("animate");

    this.setState({
      selectedPlanPricing: true,
      selectedPlanPricingId,
      selectedPlanLevel: plan,
      planProSelectPrice: Number(plan.pricing),
      planEstandarSelectPrice: 0,
      classSelectPackagePro: "plan-item-button-active",
      classSelectPackageStandar: "",
    });
  };
  /**
   * @author Martín Sánchez
   * @description start the animation when select a plan
   * @param {Event} event
   * @param {Object} plan
   */
  onSelectPlan = (event, plan) => {
    event.preventDefault();
    let selectedPlanPricingId = plan.id;
    let card = false;
    let a3Direct = true;
    let transfer = false;

    if (plan.id === Number(process.env.REACT_APP_PLAN_STANDAR_PLUS)) {
      card = false;
      a3Direct = true;
    }

    this.setState({
      selectedPlanPricing: true,
      card,
      a3Direct,
      transfer,
      selectedPlanPricingId,
      selectedPlanLevel: plan,
      planProSelectPrice: plan.pricing,
      planEstandarSelectPrice: "$0.00",
      classSelectPackagePro: "plan-item-button-active",
      classSelectPackageStandar: "",
    });
  };

  onSelectPlanPaquetStandard = (event) => {
    event.preventDefault();
  };

  onSelectPlanPaquetPro = (event) => {
    event.preventDefault();
  };

  /**
   * @author Leonel Contreras
   * @description change the personTypeId
   * @param {Number} personTypeId
   */
  onSelectPersonType = (personTypeId, personTypeName) => {
    return this.setState({
      selectedPersonType: true,
      selectedPersonTypeName: personTypeName,
      selectedPersonTypeId: personTypeId,
    });
  };

  /**
   * @author Leonel Contreras
   * @description determine the step number
   * @param {Number} step
   */
  changeStepNumber = (step) => {
    let stepLenght = this.state.physicalSteps.length - 1
    step = step >= stepLenght ? stepLenght : step + 1;
    return step;
  };

  /**
   * @author Leonel Contreras
   * @description Check if is necesary update the translates
   * @param {Object[]} steps
   * @param {Function} t
   */
  changeTranslates = (steps, t, i18n) => {
    if (!this.state.changedTranslates && i18n.language !== "es-MX") {
      let translates = this.getTranslates(steps, t);

      for (let i = 0; i < steps.length; i++) {
        const step = steps[i];

        for (let j = 0; j < translates.length; j++) {
          const translate = translates[j];

          if (step.key === translate.key) {
            step.label = translate.value;
          }
        }
      }

      return this.setState({ steps, changedTranslates: true });
    }
  };

  /**
   * @author Leonel Contreras
   * @description Get the required translates
   * @param {Object[]} steps
   * @param {Function} t
   */
  getTranslates = (steps, t) => {
    let translates = [];

    steps.forEach((step) => {
      let translate = t(step.key);
      translates.push({ key: step.key, value: translate });
    });

    return translates;
  };

  /**
   * @author Leonel Contreras
   * @description subtract one to step or returned to select person type
   * if step is zero
   * @param {number} step
   */
  /////Modificar este
  stepBack = (step) => {
    // if (this.state.preload && step === 0) {
    //   this.setState({ selectedPersonType: true })
    //   //  window.location.reload()
    // } else
    if (step === 0) {
      this.setState({ selectedPersonType: true });
      this.onCloseSesion();
    } else if (step === 2) {
      step = step - 2;
    } else if (this.state.promotion && step === 3) {
      step = step - 2;
    } else {
      step = step - 1;
    }

    return step;
  };

  /**
   * @author Leonel Contreras
   * @description Change the state when click return button in stepper
   * @param {Event} event
   */
  onBackStep = async (event) => {
    event.preventDefault();
    let stepNumber = this.stepBack(this.state.selectedStep);
    this.setState({ selectedStep: stepNumber });
  };

  /**
   * @author Leonel Contreras
   * @description Check if the plan is selected
   */
  validatePlan = async () => {
    if (!(this.state.assignedPlans[0] || this.state.assignedPackage[0])) {
      await this.toggleWarningRequesting(
        true,
        this.props.t("registration.action.pleaseSelect")
      );
      return false;
    } else {
      return true;
    }
  };

  /**
   * @author Leonel Contreras
   * @description Check if the contract is selected
   */
  validateContract = async () => {
    if (!this.state.termnsAndConditions) {
      await this.toggleWarningRequesting(
        true,
        this.props.t("registration.action.pleaseTos")
      );
      return false;
    } else if (!this.state.planChecked) {
      await this.toggleWarningRequesting(
        true,
        this.props.t("registration.action.pleaseConfirm")
      );
      return false;
    } else {
      return true;
    }
  };

  validatePaymentMethod = async () => {
    if (this.state.transfer || this.state.card || this.state.a3Direct) {
      if (this.state.transfer) {
        if (this.state.messageTransfer) {
          return true;
        } else {
          await this.toggleWarningRequesting(
            true,
            this.props.t("registration.action.acceptTransferMessage")
          );
          return false;
        }
      } else if (this.state.card) {
        var creditCardDate = moment(this.state.expirationDate, "MM/YY");
        var today = moment();
        if (
          creditCardDate.isValid() &&
          today <= creditCardDate.add(1, "months")
        ) {
          return true;
        } else {
          await this.toggleWarningRequesting(
            true,
            "Al parecer la tarjeta a expirado, Inténtalo nuevamente."
          );
          return false;
        }
      } else if (this.state.a3Direct) {
        return true;
      } else {
        return false;
      }
    } else {
      await this.toggleWarningRequesting(
        true,
        this.props.t("registration.action.selectPaymentType")
      );
      return false;
    }
  };

  /**
   * @author Leonel Contreras
   * @description Close the modal after some time
   */
  handleMessage = () => {
    setTimeout(() => {
      this.onCloseOpenModal();
    }, 15000);
  };

  async fetchClientImage() {
    let result = await this.clientService.getClientImage(this.token);
    return result?.data?.image;
  }

  /**
   * @author Lucia Alvarao
   * @description Handle the submit event
   * @param {Object} dataItem
   */
  onSubmit = async (dataItem) => {
    let { selectedPersonTypeId, selectedStep } = this.state;
    let stepNumber = this.changeStepNumber(selectedStep);
    let isIndividual = selectedPersonTypeId === 1;
    let action =
      this["physicalStepMetadata"][
        selectedStep
      ].action;
    let result = true;
    let newDataItem = {};
    if (this.state.contractCreated) {
      return this.setState({ selectedStep: stepNumber, isLastStep: true });
    }

    if (action) {
      // Only when the submit step requires an action the result is evaluated
      result = await this[action](dataItem);
      this.handleMessage();
      if (!result) return false;
    }

    if (result) {
      // When result its ok, we can flow to next steps
      if (
        (isIndividual && selectedStep === 0)) {
        let userCapturedInformation = {
          firstName: dataItem.firstName || this.state.firstName,
          firstLastName: dataItem.firstLastName || this.state.firstLastName,
          secondLastName: dataItem.secondLastName || this.state.secondLastName,
          rfc: dataItem.rfc || this.state.rfc,
          phoneNumber: dataItem.phoneNumber || this.state.phoneNumber,
          cellphoneNumber:
            dataItem.cellphoneNumber || this.state.cellphoneNumber,
          colony: dataItem.colony || this.state.colony,
          state: dataItem.state || this.state.state,
          street: dataItem.street || this.state.street,
          township: dataItem.township || this.state.township,
          zipCode: dataItem.zipCode || this.state.zipCode,
          personlDataFill: true,
        };

        await this.localStorageService.setLocalStorageItem(
          "userCapturedInformation",
          userCapturedInformation
        );
        this.setState(userCapturedInformation);

        let phoneNumber =
          dataItem.cellphoneNumber || this.state.cellphoneNumber;
        let promotion = this.state.promotion;
        ///Message
        if (!this.state.cellphoneNumber) {
          await this.toggleWarningRequesting(true, ' Agregar un teléfono móvil');
          return false;
        }
        let newPhoneNumber = phoneNumber.replace("+", "");
        let message = await this.messageService.sendMessage(
          newPhoneNumber,
          promotion,
          this.user.userToken.name,
          this.token
        );

        if (message.statusCode !== 200) {
          await this.toggleWarningRequesting(true, message.message);
          return false;
        }
      }

      if (
        (isIndividual && selectedStep === 1)) {
        if (this.state.validationCode.length !== 6) {
          await this.toggleWarningRequesting(
            true,
            "El código no cumple con la cantidad de carácteres necesarios."
          );
          return;
        }
        let validationCode = this.state.validationCode;
        let codeValidator = await this.messageService.validateMessage(
          validationCode,
          this.user.userToken.name,
          this.token
        );

        if (codeValidator.data) {
          this.setState({
            validationCodeCorrect: true,
            validationType: codeValidator.data
          });
        } else {
          await this.toggleWarningRequesting(
            true,
            "Teléfono o mensaje Incorrectos."
          );
          return false;
        }

        if (this.state.promotion) {
          return this.setState({ selectedStep: stepNumber + 1 });
        }
      }

      if (isIndividual && selectedStep === 2 && result) {
        let planPricing = [];

        if (this.state.assignedPlans[0]) {
          planPricing.push(this.state.assignedPlans[0].id);
        }
        if (this.state.assignedPackage[0]) {
          planPricing.push(this.state.assignedPackage[0].id);
        }

        this.setState({
          selectedPlanPricingId: planPricing,
        });
      }

      if (isIndividual && selectedStep === 3) {
        if (this.state.promotion) {
          stepNumber = 3;
          this.setState(
            {
              loading: true,
              firstTry: true,
              card: false,
              a3Direct: true,
            },
            async () => {
              newDataItem.firstName = this.state.firstName;
              newDataItem.firstLastName = this.state.firstLastName;
              newDataItem.secondLastName = this.state.secondLastName;
              newDataItem.rfc = this.state.rfc;
              newDataItem.phoneNumber = this.state.phoneNumber;
              newDataItem.cellphoneNumber = this.state.cellphoneNumber;
              newDataItem.colony = this.state.colony;
              newDataItem.state = this.state.state;
              newDataItem.street = this.state.street;
              newDataItem.township = this.state.township;
              newDataItem.zipCode = this.state.zipCode;
              newDataItem.personTypeId = selectedPersonTypeId;
              newDataItem.planLevelId = [
                Number(process.env.REACT_APP_PLAN_PROMOTION),
              ];
              newDataItem.clientName = this.state.clientName;
              newDataItem.rfcTaxData = this.state.rfcTaxData;
              newDataItem.streetTaxData = this.state.streetTaxData;
              newDataItem.colonyTaxData = this.state.colonyTaxData;
              newDataItem.townshipTaxData = this.state.townshipTaxData;
              newDataItem.stateTaxData = this.state.stateTaxData;
              newDataItem.zipCodeTaxData = this.state.zipCodeTaxData;
              newDataItem.paymentTypeId = process.env.REACT_APP_PAYMENT_TYPE;
              newDataItem.accountId = selectedPersonTypeId;
              newDataItem.termnsAndConditions = this.state.termnsAndConditions;
              newDataItem.eventId = this.state.eventId;
              newDataItem.userId = this.state.userId;
              newDataItem.organization = `${newDataItem.firstName} ${newDataItem.firstLastName} ${newDataItem.secondLastName}`;
              newDataItem.totalPrice = this.state.planEstandarSelectPrice;
              let promotionContract = await this.createContract(
                newDataItem,
                this.token
              );
              if (promotionContract.data) {
                this.setState({
                  selectedStep: stepNumber + 2,
                  isLastStep: true,
                });
              } else {
                await this.toggleWarningRequesting(
                  true,
                  "El contrato no pudo ser creado, Favor de intentarlo mas tarde."
                );
                return false;
              }
            }
          );
        }
      }

      if (
        (isIndividual && selectedStep === 4)) {
        if (this.state.card) {
          let date = this.state.expirationDate.split("/");

          this.setState({
            holderName: dataItem.cardName,
            cvv2: dataItem.securityCode,
            expiration_month: date[0],
            expiration_year: date[1],
          });
        }
      }
    }

    if (
      (isIndividual && selectedStep === 5)) {
      let newCellPhoneNumber = formatPhoneNumber(this.state.cellphoneNumber)
      let newPhoneNumber = formatPhoneNumber(this.state.phoneNumber)

      this.setState(
        {
          loading: true,
          firstTry: true,
        },
        async () => {
          if (this.state.assignedPlans[0]) {
            newDataItem.key = this.state.assignedPlans[0].key;
          }
          newDataItem.firstName = this.state.firstName;
          newDataItem.firstLastName = this.state.firstLastName;
          newDataItem.secondLastName = this.state.secondLastName;
          newDataItem.rfc = this.state.rfc;
          newDataItem.phoneNumber = newPhoneNumber;
          newDataItem.cellphoneNumber = newCellPhoneNumber;
          newDataItem.countryCodePhone = this.state.phoneNumber;
          newDataItem.countryCodeCellphone = this.state.cellphoneNumber;
          newDataItem.colony = this.state.colony;
          newDataItem.state = this.state.state;
          newDataItem.street = this.state.street;
          newDataItem.township = this.state.township;
          newDataItem.zipCode = this.state.zipCode;
          newDataItem.personTypeId = selectedPersonTypeId;
          newDataItem.planLevelId = this.state.selectedPlanPricingId;
          newDataItem.clientName = this.state.clientName;
          newDataItem.rfcTaxData = this.state.rfcTaxData;
          newDataItem.streetTaxData = this.state.streetTaxData;
          newDataItem.colonyTaxData = this.state.colonyTaxData;
          newDataItem.townshipTaxData = this.state.townshipTaxData;
          newDataItem.stateTaxData = this.state.stateTaxData;
          newDataItem.zipCodeTaxData = this.state.zipCodeTaxData;
          newDataItem.paymentTypeId = this.state.card
            ? 1
            : this.state.transfer
              ? 2
              : 3;
          newDataItem.accountId = selectedPersonTypeId;
          newDataItem.termnsAndConditions = this.state.termnsAndConditions;
          newDataItem.eventId = this.state.eventId;
          newDataItem.userId = this.state.userId;
          newDataItem.totalPrice = this.state.planEstandarSelectPrice;
          newDataItem.validationType = this.state.validationType

          if (isIndividual) {
            newDataItem.organization = `${newDataItem.firstName} ${newDataItem.firstLastName} ${newDataItem.secondLastName}`;
          } else {
            newDataItem.organization = newDataItem.clientName;
            newDataItem.rfc = newDataItem.rfcTaxData;
          }
          if (this.state.card) {
            newDataItem.holderName = this.state.holderName;

            window.OpenPay.setId(process.env.REACT_APP_ID);
            window.OpenPay.setApiKey(process.env.REACT_APP_API);
            window.OpenPay.setSandboxMode(
              process.env.REACT_APP_OPENPAY_SANDBOX === "true" ? true : false
            );

            newDataItem.deviceSessionId = window.OpenPay.deviceData.setup();

            window.OpenPay.token.create(
              {
                card_number: this.state.creditCard.split("-").join(""),
                holder_name: newDataItem.holderName,
                expiration_year: this.state.expiration_year,
                expiration_month: this.state.expiration_month,
                cvv2: this.state.cvv2,
              },
              async (token) => {
                newDataItem.deviceToken = token.data.id;
                await this.createChargeOpenpay(newDataItem, this.token);
              },
              (error) => {
                this.showError(error);
                return false;
              }
            );
            if (newDataItem && newDataItem?.key) {
              //set if user contract plan
              var plansHibouFlagData = {
                planHibouExist: false,
                hibouPlan: false,
                contractPlan: false,
                bovedaPlan: false
              }

              if (newDataItem.key === 'planGrcHibou') {
                plansHibouFlagData = {
                  planHibouExist: true,
                  hibouPlan: true,
                  contractPlan: false,
                  bovedaPlan: false
                }
              }

              if (newDataItem.key === 'planGrcContracts') {
                plansHibouFlagData = {
                  planHibouExist: true,
                  hibouPlan: false,
                  contractPlan: true,
                  bovedaPlan: false
                }
              }

              if (newDataItem.key === 'planGrcDigitalVault') {
                plansHibouFlagData = {
                  planHibouExist: true,
                  hibouPlan: false,
                  contractPlan: false,
                  bovedaPlan: true
                }
              }
              //save in localstorage flagplan
              this.localStorageService.setLocalStorageItem("plansHibouFlag", plansHibouFlagData);
            }
          } else if (this.state.transfer) {
            await this.createContract(newDataItem, this.token);
          } else if (this.state.a3Direct) {
            await this.createContract(newDataItem, this.token);
          }
        }
      );
    } else {
      return this.setState({ selectedStep: stepNumber });
    }
  };

  showError = (error) => {
    console.error("error", error);
    this.setState({
      contract: {},
      loading: false,
      contractCreatedError: true,
      attempOfPayment: true,
      expirationDate: "",
    });

    setTimeout(() => {
      this.setState({ contractCreatedError: false });
    }, 5000);
  };

  createChargeOpenpay = async (data, token) => {
    let charge = await this.contractService.createChargeOpenpay(data, token);
    let planSelected = [];
    if (this.state.assignedPackage)
      planSelected.push(this.state.assignedPackage);
    if (this.state.assignedPlans) planSelected.push(this.state.assignedPlans);

    this.localStorageService.setLocalStorageItem("chargeId", charge.data.id);
    this.localStorageService.setLocalStorageItem("plan-selected", planSelected);
    this.localStorageService.setLocalStorageItem("chargeURL", data);
    window.location.replace(charge.data.payment_method.url);
  };

  createContract = async (data, token) => {
    let contract = await this.contractService.createContract(data, token);
    try {
      if (contract.statusCode === 200) {
        if (this.state.transfer === true) {
          this.setState({
            creactedContract: contract.data,
            priceContract: this.formatter.format(
              contract.data.bankcharge.amount
            ),
            loading: false,
            contractCreated: true,
            folio: contract.data.id,
          });
        } else if (this.state.card) {
          this.setState({
            creactedContract: contract.data,
            priceContract: this.formatter.format(
              contract.data.contracts[0].pricing
            ),
            loading: false,
            contractCreated: true,
            creditCard: contract.data.creditCard,
            folio: contract.data.id,
          });
        } else {
          this.setState({
            creactedContract: contract.data.contracts[0],
            priceContract: this.formatter.format(
              contract.data.contracts[0].pricing
            ),
            loading: false,
            contractCreated: true,
            folio: contract.data.contracts[0].id,
          });
        }
        return contract;
      } else {
        this.showError();
        return false;
      }
    } catch (error) {
      this.showError();
      return false;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Method to clear the localStorage and close the sesion
   * @date 15-12-2020
   * @memberof RegisterUserInvitedAction
   */
  onCloseSesion = async () => {
    let logo = await this.localStorageService.getLocalStorageItem("clientLogo");
    let promotion = await this.localStorageService.getLocalStorageItem(
      "promotion"
    );
    await this.localStorageService.clearLocalStorage();
    await this.localStorageService.setLocalStorageItem(
      "clientLogo",
      logo ? logo : ""
    );
    if (promotion) {
      await this.localStorageService.setLocalStorageItem(
        "promotion",
        promotion
      );
    }
    this.auth0Service.logout();
  };

  async fetchClientImage() {
    let result = await this.clientService.getClientImage(this.token);
    return result?.data?.image;
  }

  componentDidMount = async () => {
    this.setState({ loading: true });
    this.user = this.localStorageService.getLocalStorageItem("user");
    let token = this.localStorageService.getLocalStorageItem("token");
    let userCapturedInformation = this.localStorageService.getLocalStorageItem(
      "userCapturedInformation"
    );
    let chargeId = this.localStorageService.getLocalStorageItem("chargeId");
    let chargeURL = this.localStorageService.getLocalStorageItem("chargeURL");
    let promotion = this.localStorageService.getLocalStorageItem("promotion");

    let planSelected =
      this.localStorageService.getLocalStorageItem("plan-selected");

    if (promotion === true) {
      this.setState({ promotion: true });
    }
    moment.locale("es");

    if (token) {
      this.token = token.idToken;
    } else {
      window.location.hash = "";
    }

    let plan = await this.planService.getPlanService(this.token);
    let contractBullets = await this.contractService.getContractBullets(
      this.token
    );
    let allPlan = this.getAllPlans(plan);

    let dateResumeStart = new Date();
    let dateFormatResume = moment(dateResumeStart).format("DD/MMMM/YYYY");

    await this.localStorageService.setLocalStorageItem("clientLogo", "");
    let logo = await this.fetchClientImage();
    await this.localStorageService.setLocalStorageItem(
      "clientLogo",
      logo ? logo : ""
    );

    let paymentType = await this.paymentTypeService.getPaymentType(this.token);
    let card = false;
    let a3Direct = true;

    let allPlanLevels = [];
    plan.forEach((element) => {
      element.planLevels.forEach((planLevel) => {
        let plan = [];
        planLevel.originalPrice = planLevel.pricing;
        planLevel.pricing = this.formatter.format(planLevel.pricing);

        if (planLevel.key == process.env.REACT_APP_PLAN_STANDAR_PLUS_KEY) {
          plan.push(planLevel);
          this.setState({
            assignedPlans: plan,
          });
          this.updatePricing();
        } else {
          allPlanLevels.push(planLevel);
        }

        if (planSelected) {
          planSelected.map((contract) => {
            if (contract.length > 0 && contract[0].id === planLevel.id) {
              if (planLevel.planId === 1) {
                plan.push(planLevel);
                this.setState({
                  assignedPackage: plan,
                });
              }
              if (planLevel.planId === 3) {
                plan.push(planLevel);
                this.setState({
                  assignedPlans: plan,
                });
              }
              this.updatePricing();
            }
          });
        }

        if (promotion === true) {
          if (planLevel.planId === 4) {
            plan.push(planLevel);
            this.setState({
              assignedPlans: plan,
            });
          }
        }
      });
    });

    let data = {
      plan,
      allPlan,
      contractBullets,
      paymentType: paymentType,
      selectedPersonType: true,
      reload: true,
      preload: true,
      loading: false,
      planStandard: plan[0].name,
      card,
      a3Direct,
      dateResume: dateFormatResume,
      avaliablePlans: allPlanLevels,
    };

    if (userCapturedInformation) {
      data.firstName = userCapturedInformation.firstName;
      data.firstLastName = userCapturedInformation.firstLastName;
      data.secondLastName = userCapturedInformation.secondLastName;
      data.phoneNumber = userCapturedInformation.phoneNumber;
      data.cellphoneNumber = userCapturedInformation.cellphoneNumber;
      data.rfc = userCapturedInformation.rfc;
      data.colony = userCapturedInformation.colony;
      data.state = userCapturedInformation.state;
      data.street = userCapturedInformation.street;
      data.township = userCapturedInformation.township;
      data.zipCode = userCapturedInformation.zipCode;
      data.personlDataFill = true;
    }

    // Animation view
    AOS.init({
      duration: 1000,
    });

    this.setState(data);

    if (chargeId && chargeURL) {
      if (userCapturedInformation) {
        this.setState({
          loading: true,
          selectedStep: 4,
          selectedPersonType: true,
          selectedPersonTypeId: 1,
          termnsAndConditions: true,
          planChecked: true,
        });
      }
      chargeURL.transactionId = chargeId;
      await this.createContract(chargeURL, this.token);
      this.localStorageService.deleteElementLocalStorage("chargeId");
      this.localStorageService.deleteElementLocalStorage("chargeURL");
    }
    return true;
  };

  componentDidUpdate = async (prevProps, prevState) => {
    let node = this.domUtil.findDomElementByClassAndProperty(
      "plan-item-button",
      "id",
      this.state.selectedPlanPricingId
    );
    if (prevState.termnsAndConditions !== this.state.termnsAndConditions) {
      if (this.state.termnsAndConditions) {
        let eventId = hash({ hash: Math.random().toString(36).substring(7) });
        this.setState({ eventId });
      }
    }

    if (node) {
      this.domUtil.addCssClassToDOMNode(node, "plan-item-button-active");
    }
  };

  onRegisterEnd = () => {
    window.location.reload();
  };

  onReSendMessage = async (event, validationType) => {
    event.preventDefault();
    let phoneNumber = this.state.cellphoneNumber;
    let newPhoneNumber = phoneNumber.replace("+", "");
    let message = this.messageService.reSendMessage(newPhoneNumber, validationType, this.user.userToken.name, this.token);

    if (validationType === 'phoneNumber') {
      await this.toggleCompletedRequesting(true, this.props.t("registration.action.resendMessageSMS"));
    } else if (validationType === 'mail') {
      await this.toggleCompletedRequesting(true, this.props.t("registration.action.resendMessageEmail"));
    }

    return message;
  };

  //Button Validate input
  handleClick = () => {
    this.input.current.focus();
  };

  handleFocus = () => {
    this.setState({ focused: true });
  };

  handleBlur = () => {
    this.setState({
      focused: false,
    });
  };

  handleChange = (e) => {
    const validationCode = e.target.value;
    const CODE_LENGTH = new Array(6).fill(0);

    this.setState((state) => {
      if (state.validationCode.length >= CODE_LENGTH.length) return null;
      return {
        validationCode: (state.validationCode + validationCode).slice(
          0,
          CODE_LENGTH.length
        ),
      };
    });
  };

  handleKeyUp = (e) => {
    if (e.key === "Backspace") {
      this.setState((state) => {
        return {
          validationCode: state.validationCode.slice(
            0,
            state.validationCode.length - 1
          ),
        };
      });
    }
  };

  updatePricing = () => {
    //     let formatter = new Intl.NumberFormat("en-MX", { style: 'currency', currency: 'MXN', currencyDisplay: 'narrowSymbol' }, {
    //   style: "currency",
    //   currency: "MXN",
    // })
    //Precio con Iva
    let totalPriceSub = 0;
    if (this.state.assignedPlans[0]) {
      totalPriceSub =
        totalPriceSub + Number(this.state.assignedPlans[0].originalPrice);
    }
    if (this.state.assignedPackage[0]) {
      totalPriceSub =
        totalPriceSub + Number(this.state.assignedPackage[0].originalPrice);
    }
    let totalPriceIva = totalPriceSub * 0.16;
    let totalPlanPricing = totalPriceSub + totalPriceIva;

    let totalPrice = this.formatter.format(totalPlanPricing);
    totalPriceSub = this.formatter.format(totalPriceSub);
    totalPriceIva = this.formatter.format(totalPriceIva);
    this.setState({
      planEstandarSelectPrice: totalPlanPricing,
      total: totalPrice,
      subtotal: totalPriceSub,
      iva: totalPriceIva,
    });
  };

  updateAvaliablePlans = (avaliablePlans) => {
    avaliablePlans.sort(function (a, b) {
      if (a.order > b.order) {
        return 1;
      }
      if (a.order < b.order) {
        return -1;
      }
      return 0;
    });

    return avaliablePlans;
  };

  onClickAvaliablePlans = (id, plan, event) => {
    event.preventDefault();
    this.onSelectPlanState()
    let avaliablePlans = this.state.avaliablePlans;
    let assignedPlans = this.state.assignedPlans;
    let assignedPackage = this.state.assignedPackage;

    if (assignedPackage[0]) {
      if (plan.id === 8) {
        avaliablePlans.push(assignedPackage[0]);
        assignedPackage.splice(0, 1);
      }
    }

    if (assignedPlans[0]) {
      avaliablePlans.push(assignedPlans[0]);
      assignedPlans.splice(0, 1);
    }

    if (plan.id === 8) {
      this.setState({
        card: false,
        transfer: false,
        a3Direct: true,
      });
    }

    avaliablePlans.splice(id, 1);
    assignedPlans.push(plan);

    avaliablePlans = this.updateAvaliablePlans(avaliablePlans);

    this.setState({
      avaliablePlans: avaliablePlans,
      assignedPlans: assignedPlans,
    });
    this.updatePricing();
  };

  onClickAvaliablePackage = (id, plan, event) => {
    event.preventDefault();
    this.onSelectPlanState()
    let avaliablePlans = this.state.avaliablePlans;
    let assignedPackage = this.state.assignedPackage;
    let assignedPlans = this.state.assignedPlans;

    if (assignedPackage[0]) {
      avaliablePlans.push(assignedPackage[0]);
      assignedPackage.splice(0, 1);
    }

    if (assignedPlans[0]) {
      if (assignedPlans[0].id === 8) {
        avaliablePlans.push(assignedPlans[0]);
        assignedPlans.splice(0, 1);
      }
    }

    avaliablePlans.splice(id, 1);
    assignedPackage.push(plan);

    avaliablePlans = this.updateAvaliablePlans(avaliablePlans);

    this.setState({
      avaliablePlans: avaliablePlans,
      assignedPackage: assignedPackage,
    });
    this.updatePricing();
  };

  onClickAssignedPlan = (event) => {
    event.preventDefault();
    let avaliablePlans = this.state.avaliablePlans;
    let assignedPlans = this.state.assignedPlans;

    avaliablePlans.push(assignedPlans[0]);
    assignedPlans.splice(0, 1);

    avaliablePlans = this.updateAvaliablePlans(avaliablePlans);

    this.setState({
      avaliablePlans: avaliablePlans,
      assignedPlans: assignedPlans,
    });
    this.updatePricing();
  };

  onClickAssignedPackage = (event) => {
    event.preventDefault();
    let avaliablePlans = this.state.avaliablePlans;
    let assignedPackage = this.state.assignedPackage;

    avaliablePlans.push(assignedPackage[0]);
    assignedPackage.splice(0, 1);

    avaliablePlans = this.updateAvaliablePlans(avaliablePlans);

    this.setState({
      avaliablePlans: avaliablePlans,
      assignedPackage: assignedPackage,
    });
    this.updatePricing();
  };

  render = () => {
    if (this.state.loading) {
      return <SimpleLoading />;
    } else if (!this.state.selectedPersonType) {
      return <PersonTypeView
        {...this.state}
        fisica={this.fisica}
        moral={this.moral}
        onSelectPersonType={this.onSelectPersonType}
        back={this.back}
        stepMetadata={this.personType}
        govoLogo={govoLogo}
        openModalTermsCond={this.openModalTermsCond}
      />
      // } else {
    } else if (this.state.selectedPersonTypeId === 1) {
      return (
        <UserRegisterView
          {...this.state}
          fisica={this.fisica}
          onSelectPersonType={this.onSelectPersonType}
          back={this.back}
          goToApp={() => this.onRegisterEnd(this.state.contract)}
          stepperIsLastStep={this.stepperIsLastStep}
          downloadLoading={this.state.downloadLoading}
          onSelectPlanStandard={this.onSelectPlanStandard}
          onSelectPlanPro={this.onSelectPlanPro}
          notification={this.notification}
          validator={this.validator}
          onCloseOpenModal={this.onCloseOpenModal}
          validateInput={ValidateInputPure}
          steps={this.state.physicalSteps}
          stepMetadata={this.physicalStepMetadata}
          getTranslates={this.getTranslates}
          changeTranslates={this.changeTranslates}
          onSubmitClick={this.onSubmitClick}
          onSubmit={this.onSubmit}
          onBackStep={this.onBackStep}
          planCheckFeature={this.planCheckFeature}
          onSelectPlanLevel={this.onSelectPlanLevel}
          onSelectPlanPaquet={this.onSelectPlanPaquet}
          onSelectPlanPaquetStandard={this.onSelectPlanPaquetStandard}
          onSelectPlanPaquetPro={this.onSelectPlanPaquetPro}
          onAcceptTermnsAndConditions={this.onAcceptTermnsAndConditions}
          onAcceptPlan={this.onAcceptPlan}
          onAcceptCard={this.onAcceptCard}
          onAcceptTransfer={this.onAcceptTransfer}
          onAcceptA3Direct={this.onAcceptA3Direct}
          onAcceptMessageTransfer={this.onAcceptMessageTransfer}
          principal={this.personType}
          warning={this.state.warning}
          handleWarning={this.handleWarning}
          onSelectPlan={this.onSelectPlan}
          topScroll={true}
          onHandleHideError={this.onHandleHideError}
          toggleErrorRequesting={this.toggleErrorRequesting}
          toggleWarningRequesting={this.toggleWarningRequesting}
          toggleCompletedRequesting={this.toggleCompletedRequesting}
          openModalTermsCond={this.openModalTermsCond}
          onCloseSesion={this.onCloseSesion}
          onChangeValue={this.onChangeValue}
          onReSendMessage={this.onReSendMessage}
          handleClick={this.handleClick}
          handleFocus={this.handleFocus}
          handleBlur={this.handleBlur}
          handleChange={this.handleChange}
          handleKeyUp={this.handleKeyUp}
          input={this.input}
          onClickAvaliablePlans={this.onClickAvaliablePlans}
          onClickAvaliablePackage={this.onClickAvaliablePackage}
          onClickAssignedPlan={this.onClickAssignedPlan}
          onClickAssignedPackage={this.onClickAssignedPackage}
          onChangePhone={this.onChangePhone}
          onChangeCellphone={this.onChangeCellphone}
        />
      );
    }
  };
}

function RegistrationActionContainer(props) {
  const { t } = useTranslation();
  return <RegistrationAction {...props} t={t} />;
}

export default scriptLoader([
  "https://ajax.googleapis.com/ajax/libs/jquery/1.11.0/jquery.min.js",
  "https://js.openpay.mx/openpay.v1.min.js",
  "https://js.openpay.mx/openpay-data.v1.min.js",
])(RegistrationActionContainer);
